import type { IconName } from '@/components/Icon';
import type { StepKind } from '@/types/sturm';

export const STEP_KIND_ICON: Record<StepKind, IconName> = {
  activity: 'cube',
  child: 'flow',
  timer: 'clock',
  signal: 'signal',
};
